import { ChevronDown, X } from 'lucide-react';
import type { ReactNode } from 'react';
import { IconButton } from '../IconButton';

interface ContextPanelProps {
  readonly title: string;
  readonly eyebrow?: string;
  readonly children: ReactNode;
  readonly onClose: () => void;
  readonly collapsed?: boolean;
  readonly onToggleCollapsed?: () => void;
}

export function ContextPanel({ title, eyebrow, children, onClose, collapsed = false, onToggleCollapsed }: ContextPanelProps) {
  return (
    <aside className={`context-panel ${collapsed ? 'is-collapsed' : ''}`} aria-label={title}>
      <header className="context-panel__header">
        <div>
          {eyebrow ? <span>{eyebrow}</span> : null}
          <h2>{title}</h2>
        </div>
        <div className="context-panel__actions">
          {onToggleCollapsed ? (
            <IconButton icon={ChevronDown} label={collapsed ? 'Expandir panel' : 'Contraer panel'} onClick={onToggleCollapsed} />
          ) : null}
          <IconButton icon={X} label="Cerrar panel" onClick={onClose} />
        </div>
      </header>
      <div className="context-panel__body">{children}</div>
    </aside>
  );
}
